import React, {
    useEffect, useState,
} from 'react';
import {
    useObserver,
} from 'mobx-react';
import {Button, Checkbox, FormControlLabel, TextField} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from 'constants/pagination';
import {
    RequestStatus,
    stores,
} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
    TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
    translate,
} from '../../helperFunctions/translation';
import {
    CardsDeliveryRequestDTO,
} from './DTOs/cardsDeliveryRequestDTO';
import SearchFilterDropdown from '../../components/SearchFilterComponent/SearchFilterDropdown';
import classes from './cardDelivery.module.scss';
import {
    CardRequestType,
    CardsDeliveryStatus,
    PaymentMethodsLabels,
    StatusLabels,
} from './types';
import AddressDetailsModal from './addressDetailsModal';
import MultiSearchFilterDropdown from 'components/MultiSearchFilterComponent/MultiSearchFilterDropdown';
import { TransactionStatus } from 'mobx-store/storeInterfaces/transactionInterface';

const formatDate = (date: Date) => {
    if (!date) return '';
    date = new Date(date);
    const formattedDate = `${((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()}`
    return formattedDate;
  };

const CardsDeliveryRequestsTableScreen: React.FC = () => {
    let statusFilterRef: SearchFilterDropdown;
    let branchFilterRef: SearchFilterDropdown;
    let paymentFilterRef: SearchFilterDropdown;

    const [filterOptions, setFilterOptions] = useState<any>({
        status: CardsDeliveryStatus.All,
        paymentStatuses: [TransactionStatus.PROCCESSING, TransactionStatus.SUCCEEDED],
        requestType: CardRequestType.HomeDelivery
    });

    const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
    const [paid, setPaid] = useState(true);
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
    const [isModalOpen, setModalOpen] = useState(false);
    const [requestId, setRequestId] = useState(0);

    const onStatusChange = (status: any) => {
        const searchParams = {...filterOptions, status};
        setFilterOptions(searchParams);
    };
    const onSearchQueryChange = (q: string) => {
        const searchParams = {...filterOptions, q};
        setFilterOptions(searchParams);
    };
    const onFromDateChange = (from: any) => {
        const searchParams = {...filterOptions, from: formatDate(from)};
        setFilterOptions(searchParams);
    };
    const onToDateChange = (to: any) => {
        const searchParams = {...filterOptions, to: formatDate(to)};
        setFilterOptions(searchParams);
    };
    const onPickupBranchChange = (branch: string) => {
        const searchParams = {...filterOptions, branch};
        setFilterOptions(searchParams);
    };
    const onPaymentMethodChange = (payment: string) => {
        const searchParams = {...filterOptions, payment};
        setFilterOptions(searchParams);
    };

    const paymentStatusChanged = (paymentStatuses: TransactionStatus []) => {
        const searchParams = {...filterOptions, paymentStatuses};
        setFilterOptions(searchParams);
    }

    const cardRequestTypeChanged = (requestType: CardRequestType) => {
        const searchParams = {...filterOptions, requestType};
        setFilterOptions(searchParams);

    }

    const getCardsDelivery = (params = filterOptions, page = pageNumber) => {
        stores.cardsDeliveryStore.getCardsDeliveryRequestsList(page, DEFAULT_PAGE_SIZE, params)
            .then((r) => {
                setTotalNumberOfPages(Math.ceil(stores.cardsDeliveryStore.requestsCount / DEFAULT_PAGE_SIZE));
            });
    };

    const toDateError = () => {
        const hasError = !!filterOptions.from && !!filterOptions.to && (
            new Date(filterOptions.to) < new Date(filterOptions.from)
        );
        return hasError;
    };

    const handleFilterClick = () => {
        if (!toDateError()) {
            setPageNumber(1);
            const filters = {...filterOptions, paid }
            getCardsDelivery(filters, 1);
        }
    };

    const handleClearClick = () => {
        setPaid(false)
        statusFilterRef.setState({
            status: `${CardsDeliveryStatus.All}`,
        });
        branchFilterRef.setState({
            status: 'any',
        });
        paymentFilterRef.setState({
            status: 'all',
        });
        setFilterOptions({ status: CardsDeliveryStatus.All });
        getCardsDelivery({ status: CardsDeliveryStatus.All });
    };

    const handleDownloadClick = async () => {
        if (!toDateError()) {
            const filters = {...filterOptions, paid }
            await stores.cardsDeliveryStore.exportCardDelivery(filters);
        }
    };

    useEffect(() => {
        (async function () {
            let filters={...filterOptions,paid}
            await getCardsDelivery(filters);
            await stores.cardsDeliveryStore.getBranchesOptions();
        }());
    }, []);

    const tableHeaders = [
        {
            title: 'Request ID',
        },
        {
            title: 'Membership ID',
        },
        {
            title: 'Name',
        },
        {
            title: 'Phone',
        },
        {
            title: 'Address',
        },
        {
            title: 'Pickup Branch',
        },
        {
            title: 'Cost',
        },
        {
            title: 'Payment Method',
        },
        {
            title: 'Status',
        },
        {
            title: 'Main',
        },
        {
            title: 'Update Status',
        },
    ];

    const handleViewAddressDetailsClicked = (index: number) => {
        setRequestId(stores.cardsDeliveryStore.cardsDeliveryRequestsList[index].requestId);
        setModalOpen(true);
    };

    const disableViewAddress = (index: number) => (
        stores.cardsDeliveryStore.cardsDeliveryRequestsList[index].requestType === CardRequestType.BranchPickup
    );

    const disableUpdateStatus = (index: number) => (
        stores.cardsDeliveryStore.cardsDeliveryRequestsList[index].status === CardsDeliveryStatus.Returned ||stores.cardsDeliveryStore.cardsDeliveryRequestsList[index].cost==0
    );

    const updateCardReqStatus = async (index: number) => {
        const {
            requestId, requestType, status,
        } = stores.cardsDeliveryStore.cardsDeliveryRequestsList[index];
        if (requestType === CardRequestType.BranchPickup && status === CardsDeliveryStatus.Ordered) {
            await stores.cardsDeliveryStore.updateCardStatus(requestId, CardsDeliveryStatus.Delivered);
        } else {
            const followingStatus = status + 1;
            await stores.cardsDeliveryStore.updateCardStatus(requestId, followingStatus);
        }
        await getCardsDelivery();
    };

    const cellTypes: TableCellTypes[] = [
        {
            cellType: 'Text',
            key: 'requestId',
        },
        {
            cellType: 'Text',
            key: 'membershipId',
        },
        {
            cellType: 'Text',
            key: 'name',
        },
        {
            cellType: 'Text',
            key: 'phone',
        },
        {
            cellType: 'Button',
            key: 'address',
            onClick: handleViewAddressDetailsClicked,
            disabled: disableViewAddress,
        },
        {
            cellType: 'Text',
            key: 'pickupBranch',
        },
        {
            cellType: 'Text',
            key: 'cost',
        },
        {
            cellType: 'Text',
            key: 'paymentMethod',
        },
        {
            cellType: 'Text',
            key: 'status',
        },
        {
            cellType: 'Text',
            key: 'main',
        },
        {
            cellType: 'Button',
            onClick: updateCardReqStatus,
            key: 'updateStatus',
            disabled: disableUpdateStatus,
        },
    ];

    const getNextStatusLabel = (requestType: CardRequestType, status: number) => {
        if (!StatusLabels[status]) {
            return 'Ordered';
        }
        if (requestType === CardRequestType.BranchPickup && status === CardsDeliveryStatus.Ordered) {
            return 'Set Received';
        }
        if (status === CardsDeliveryStatus.Returned) {
            return StatusLabels[status];
        }
        return `Set ${StatusLabels[status + 1]}`;
    };

    const getPickupBranchesOptions = () => {
        const branchOptions: any[] = [
            {
                value: 'any',
                name: 'Any Request',
            },
            {
                value: 'allBranchesOnly',
                name: 'All Branches',
            },
        ];
        stores.cardsDeliveryStore.pickupBranchesList.forEach((branch) => {
            branchOptions.push({
                value: branch,
                name: branch,
            });
        });
        return branchOptions;
    };

    const getPaymentMethodOptions = () => Object.entries(PaymentMethodsLabels).map(
        ([key, value]) => ({
            value: key,
            name: value,
        }),
    );

    const isPickup = (reqType: any) => reqType === CardRequestType.BranchPickup;

   const leftArrowClicked = async () => {
        const page=pageNumber-1
       setPageNumber(page);
       getCardsDelivery(filterOptions,page);
    };
    const rightArrowClicked = async () => {
        const page=pageNumber+1;
        setPageNumber(page);
        getCardsDelivery(filterOptions,page);
    };

    const getTableData = () => stores.cardsDeliveryStore.cardsDeliveryRequestsList.map(
        (cdReq: CardsDeliveryRequestDTO) => ({
            requestId: cdReq.requestId,
            membershipId: cdReq.membershipId,
            name: cdReq.userFirstName,
            phone: cdReq.phone,
            address: translate('viewAddressButton'),
            pickupBranch:  cdReq.pickupBranch ,
            cost: cdReq.cost,
            paymentMethod: PaymentMethodsLabels[cdReq.paymentMethod],
            status: StatusLabels[cdReq.status],
            updateStatus: cdReq.cost>0?getNextStatusLabel(cdReq.requestType, cdReq.status):'pickUp',
            main: `${cdReq.main}`,
         }),
    );

    return useObserver(() => (
        <>
            <div className={classes.filters}>
                <TextField
                    className={classes.input}
                    placeholder={'Search Membership IDs or Phone Numbers'}
                    value={filterOptions.q || ""}
                    label={'Search'}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handleFilterClick();
                        }
                    }}
                    onChange={(text) => {
                        onSearchQueryChange(text.target.value);
                    }}
                />
                <div className={classes.datesGroup}>
                <DatePicker
                    variant="inline"
                    className={classes.datePicker}
                    label="Search By Date From"
                    name="fromDate"
                    format="dd/MM/yyyy"
                    value={filterOptions.from || null}
                    views={['year', 'month', 'date']}
                    onChange={(value) => {
                    onFromDateChange(value as any || new Date() as any);
                    }}
                    disableFuture
                />
                <DatePicker
                    variant="inline"
                    className={classes.datePicker}
                    label="To"
                    name="toDate"
                    format="dd/MM/yyyy"
                    value={filterOptions.to || null}
                    views={['year', 'month', 'date']}
                    onChange={(value) => {
                    onToDateChange(value as any || new Date() as any);
                    }}
                    disableFuture
                    error={toDateError()}
                    helperText={toDateError() ? "Must be after Start date" : ""}
                />
                </div>
                <div>
                    <MultiSearchFilterDropdown
                    label='Payment Status'
                    searchFilterDropdown={{
                        value: filterOptions.paymentStatuses,
                        onChange: paymentStatusChanged,
                        filters: Object.values(TransactionStatus).filter(s => s !== TransactionStatus.ALL).map(s => ({ name: s, value: s})),
                    }}
                    />
                </div>
                <SearchFilterDropdown
                    label="Cards request Type"
                    searchFilterDropdown={{
                        value: filterOptions.requestType,
                        onChange: cardRequestTypeChanged,
                        filters: Object.values(CardRequestType).map(t => ({ name: t, value: t})),
                    }}
                />
                <SearchFilterDropdown
                    label="Status"
                    ref={(ref) => {
                        if (ref) statusFilterRef = ref;
                    }}
                     
                    searchFilterDropdown={{
                        value: filterOptions.status,
                        onChange: (status: any) => {
                            onStatusChange(status);
                        },
                        filters: [
                            {
                                value: CardsDeliveryStatus.All,
                                name: 'All',
                            },
                            {
                                value: CardsDeliveryStatus.Ordered,
                                name: 'Ordered',
                            },
                            {
                                value: CardsDeliveryStatus.OutForDelivery,
                                name: 'Out For Delivery',
                            },
                            {
                                value: CardsDeliveryStatus.Delivered,
                                name: 'Delivered',
                            },
                            {
                                value: CardsDeliveryStatus.Returned,
                                name: 'Returned',
                            },
                        ],
                    }}
                />
                <SearchFilterDropdown
                    label="Pickup Branch"
                    ref={(ref) => {
                        if (ref) branchFilterRef = ref;
                    }}
                    searchFilterDropdown={{
                        value: filterOptions.branch || 'any',
                        onChange: (val: string) => {
                            onPickupBranchChange(val);
                        },
                        filters: getPickupBranchesOptions(),
                    }}
                />
                <SearchFilterDropdown
                    label="Payment Method"
                    ref={(ref) => {
                        if (ref) paymentFilterRef = ref;
                    }}
                    searchFilterDropdown={{
                        value: filterOptions.payment || 'all',
                        onChange: (val: string) => {
                            onPaymentMethodChange(val);
                        },
                        filters: [
                            {
                                value: 'all',
                                name: 'All',
                            },
                            ...getPaymentMethodOptions(),
                        ]
                    }}
                />
            </div>
            <div className={classes.filterButtons}>
                <Button color="primary" variant="contained" onClick={handleFilterClick}>
                    Filter
                </Button>
                <Button color="primary" variant="contained" onClick={handleDownloadClick}>
                    Download
                </Button>
                <Button color="default" variant="contained" onClick={handleClearClick}>
                    Clear
                </Button>
            </div>
            <GeneralTableComponent
                title={translate('cardsDeliveryTableTitle')}
                emptyMessage={translate('emptyTable')}
                tableHeader={tableHeaders}
                tableData={getTableData()}
                tableCellTypes={cellTypes}
                loading={stores.cardsDeliveryStore.getCardsDeliveryReqListRequestStatus === RequestStatus.LOADING}
                loadingStatus={[
                    stores.cardsDeliveryStore.getCardsDeliveryReqListRequestStatus,
                ]}
                hadPagination
                paginationAction={{
                    handleClickLeftArrow: leftArrowClicked,
                    handleClickRightArrow: rightArrowClicked,
                    pageNumber,
                    totalNumberOfPages,
                }}
            />
            { isModalOpen && (
                <AddressDetailsModal
                    handleClose={() => {
                        setModalOpen(false);
                        setRequestId(0);
                    }}
                    modalOpen={!!requestId && isModalOpen}
                    requestId={requestId}
                />
            )}
        </>
    ));
};

export default CardsDeliveryRequestsTableScreen;
